import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

function Cart() {
    const [cart, setCart] = useState(null);
    const [items, setItems] = useState([]);
    const userId = localStorage.getItem("userId");

    // Fetch cart data from API
    useEffect(() => {
        axios
            .get(`https://api.irfanelectricals.com/api/cart/${userId}`)
            .then((response) => {
                if (response.data.success) {
                    setCart(response.data.cart);
                    setItems(response.data.items);
                }
            })
            .catch((error) => {
                console.error("Error fetching cart:", error);
            });
    }, []);

    // Remove item from cart
    const removeItem = (itemId) => {
        axios
            .delete(`https://api.irfanelectricals.com/api/cart/${userId}/item/${itemId}`)
            .then(() => {
                setItems(items.filter(item => item.id !== itemId));
            })
            .catch((error) => console.error("Error removing item:", error));
    };

    return (
        <>
            <Navbar />
            <section id="center" className="center_o pt-5 pb-5 bg_light">
                <div className="container-xl">
                    <div className="row center_o1 text-center">
                        <div className="col-md-12">
                            <h1 className="text-uppercase">Shopping Cart</h1>
                            <h6 className="d-inline-block mb-0 col_yell">
                                <a href="/">Home</a> <span className="mx-2 text-muted">/</span> Shopping Cart
                            </h6>
                        </div>
                    </div>
                </div>
            </section>

            <section id="cart_page" className="cart pt-4 pb-4">
                <div className="container-xl">
                    <div className="cart_2 row">
                        <div className="col-md-6">
                            <h5>MY CART</h5>
                        </div>
                        <div className="col-md-6">
                            <h5 className="text-end text-uppercase">
                                <a href="#">Continue Shopping</a>
                            </h5>
                        </div>
                    </div>

                    <div className="cart_3 row mt-3">
                        <div className="col-md-8">
                            <div className="cart_3l">
                                <h6>PRODUCT</h6>
                            </div>

                            {items.length === 0 ? (
                                <h5 className="text-center mt-3">Your cart is empty.</h5>
                            ) : (
                                items.map((item) => (
                                    <div key={item.id} className="cart_3l1 mt-3 row ms-0 me-0">
                                        <div className="col-md-3 ps-0 col-3">
                                            <div className="cart_3l1i">
                                                <img
                                                    src={item.images.length > 0 ? `https://api.irfanelectricals.com/uploads/${item.images[0]}` : "https://via.placeholder.com/150"}
                                                    alt={item.product_name}
                                                    className="w-100"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-9 col-9">
                                            <div className="cart_3l1i1">
                                                <h6 className="fw-bold">{item.product_name}</h6>
                                                <h6 className="fw-normal font_12 mt-3">Quantity: {item.quantity}</h6>
                                                <h5 className="col_yell mt-3">${item.price}</h5>
                                            </div>
                                            <div className="cart_3l1i2">
                                                <button className="button_1" onClick={() => removeItem(item.id)}>REMOVE</button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>

                        <div className="col-md-4">
                            <div className="cart_3r">
                                <h6 className="head_1">SUBTOTAL</h6>
                                <h5 className="text-center col_yell mt-3">${cart ? cart.total_price : 0}</h5>
                                <hr />
                                <h6 className="text-center mt-3">
                                    <a className="button" href="/checkout">
                                        PROCEED TO CHECKOUT
                                    </a>
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}

export default Cart;
